import React from 'react';
import PropTypes from 'prop-types';

import gh from './grid.helper';
import Pagination from '../../pagination';
import ColumnTitle from './columnTitle';
import DataCell from './dataCell';
import CheckBox from './checkBox';
import Confirm from '../../confirm';

const Grid = ({ data,
  showHeader,
  columns,
  showConfirm,
  hideConfirm,
  confirmCallback,
  service,
  count,
  noItemsGrid,
  updateData,
  destroyItem,
  goToPage,
  criteria,
  checked,
  sort,
  paginationColor,
  updateUser,
  updateChecked,
  backgroundColor,
  positions,
  showChecked,
  current,
}) => (
  <div className="grid forscrollgrid">
    { !noItemsGrid ?
      <div>
        <table className="tb">
          <thead >
            {showHeader && (
              <tr className="tb-tr">
                {(showChecked === undefined || showChecked) &&
                <CheckBox index={-1} updateChecked={updateChecked} checked={checked[-1]} />}
                {columns.map((column, i) =>
              (<ColumnTitle
                key={gh.thId(column)}
                column={column}
                criteria={criteria}
                sort={sort}
                position={positions[i]}
              />))}
              </tr>
        )}
          </thead>
          <tbody className={paginationColor}>
            {data.map((item, index) => (
              <tr
                key={gh.trId(item)}
                className={`tb-tr
                  ${paginationColor ? ' tc ' : ''}
                   ${current && item.id === current.id ? ' tb-tr_act' : ' tb-tr_dis'}`}
              >
                {(showChecked === undefined || showChecked) && <CheckBox
                  index={item.id}
                  updateChecked={updateChecked}
                  checked={checked[item.id]}
                />}
                {columns.map((column, i) => (<DataCell
                  key={gh.tdId(item, column)}
                  service={service}
                  column={column}
                  item={item}
                  index={index + 1}
                  updateData={updateData}
                  destroyItem={destroyItem}
                  position={positions[i]}
                  updateUser={updateUser}
                />))}
              </tr>
        ))}
          </tbody>
        </table>
        <div className="pull-right">
          <Pagination
            color={paginationColor}
            goToPage={goToPage}
            count={count}
            pageSize={criteria.limit}
            page={criteria.page}
            backgroundColor={backgroundColor}
          />
        </div>
      </div> :
      <div className="error-search">
        <div className="error-message error-message_md">{noItemsGrid}</div>
      </div>}
    <Confirm show={showConfirm} cancelCallback={hideConfirm} successCallback={confirmCallback} />
  </div>
);

Grid.propTypes = {
  data: PropTypes.array.isRequired,
  sort: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired,
  service: PropTypes.object.isRequired,
  checked: PropTypes.object,
  criteria: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  showHeader: PropTypes.bool.isRequired,
  positions: PropTypes.array.isRequired,
  updateUser: PropTypes.func.isRequired,
  updateChecked: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ])),
  paginationColor: PropTypes.string,
};

Grid.defaultProps = {
  columns: [
    'id',
  ],
};

export default Grid;



// WEBPACK FOOTER //
// ./src/components/list/grid/Grid.jsx